import { ClientLoaderFunctionArgs, useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaDescriptorProps } from "@features/seo/utils/types";
import { Route } from "@route-types/Videos/VideosPage/+types/VideosPage";
import { fetchContext, ResponseType } from "@sphtech/web2-core/ssr";
import { createMetaTags } from "@sphtech/web2-seo-schema";
import { HttpStatusCode } from "axios";

import { VideosPageContext } from "./utils/types";
import { fetchVideosPageData } from "./VideosPage.server";
import VideosPageContent from "./VideosPageContent";

/** This is the main entry point component for /videos route. */
const VideosPage = (): React.ReactElement => {
  const context = useLoaderData<VideosPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <VideosPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default VideosPage;

export const loader = async () => await fetchVideosPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaDescriptorProps[] => {
  const context = loaderData as VideosPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return createMetaTags(data.metaTags);
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const result = (await fetchContext(args)) as {
    context?: VideosPageContext;
  };

  if (!result.context) return await args.serverLoader();

  return result.context;
};
